<template>
    <reports-base
        page-size-changeable
        exportable
        reportsName="promoUsage"
        reportsTitle="Raport/ Użycia promocji"
        componentName="PromoUsage"
        @onExport="onExport"
    >
        <div class="c-thead">
            <div class="c-tw w-left">
                <div class="c-td is-1">Detalista</div>
                <div class="c-td is-2">Kasa</div>
            </div>
            <div class="c-tw w-right">
                <div class="c-td is-3">Promocja</div>
                <div class="c-td is-4 text-center">Data</div>
                <div class="c-td is-5">Liczba użyć</div>
                <div class="c-td is-6">Kwota refundacji</div>
            </div>
        </div>
    </reports-base>
</template>

<script>
import ReportsBase from '@/components/reports/ReportsBase'

export default {
    components: {
        ReportsBase
    },
    methods: {
        onExport() {
            this.$store.dispatch('fetchPromotionUsageReport')
        }
    }
}
</script>